import type { RootState } from '../types';

const EMPTY_ARRAY: readonly never[] = [];
const EMPTY_OBJECT: Record<string, never> = {};

export const authSelectors = {
  authData: (state: RootState) => state.authPersist.data || EMPTY_OBJECT,
  mfaInfo: (state: RootState) => state.auth.mfaInfo || EMPTY_OBJECT,
  userContacts: (state: RootState) => state.auth.userContacts || EMPTY_ARRAY,
  userContactMapping: (state: RootState) =>
    state.auth.userContactMapping || EMPTY_OBJECT,
};
